import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
              private afAuth: AngularFireAuth){}
              
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,): Observable<boolean> | Promise<boolean> | boolean {
    
    return this.afAuth.authState.map(user => {
      if (!user) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/auth.guard.ts